import httpClient from '@/lib/httpClient'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useGetTwoFactorQrCode() {
  const action = async () => {
    const response = await httpClient.get('auth/user/two-factor-qr-code')
    return response.data
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) => toast.error(error.message),
    onSuccess: (res, variables) => {
      // toast.success('Two factor authentication qr code generated')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
